import React from 'react';

export default function HomePage() {
  return (
    <React.Fragment>
      <h1>Welcome to Kevin Bugusky's Portfolio!</h1>
      <p>
      Originally from Illinois, I have made a new home here in Austin Texas. I enjoy coding, learning,
      chess, mathematics, computers, movies, coffee, pens, music, and sports. <br></br><br></br>
      I have spent the last decade teaching mathematics and computer science. Molding young minds is a
      rewarding job that has given me memories and friendships forever. Now, I am pursuing my
      dreams and going into coding full-time! I particular am intersted in fullstack developing in JS 
      or Python. I have now completed a fullstack bootcamp through UT! I am excited to apply my new skils.
      </p>
      <img id="kev-img" src="./images/Kevin-Bugusky.jpg" alt="Kevin Bugusky in a suit"/>
    </React.Fragment>
  );
}
